import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicyNL() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Terug naar App
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacybeleid</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Laatst bijgewerkt: {new Date().toLocaleDateString()}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Verwerkingsverantwoordelijke</h2>
              <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>De verwerkingsverantwoordelijke is:</strong>
                </p>
                <div className="ml-4 space-y-1">
                  <p><strong>Naam:</strong> Puretech s.r.o.</p>
                  <p><strong>Registratienummer:</strong> 05503795</p>
                  <p><strong>Locatie:</strong> Tsjechische Republiek</p>
                  <p><strong>Contact:</strong> support@simplestickers.app</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Informatie die wij verzamelen</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Accountinformatie:</strong> Wanneer u een account aanmaakt, verzamelen wij uw e-mailadres en eventuele profielinformatie die u kiest te verstrekken.
                </p>
                <p className="leading-relaxed">
                  <strong>Gebruiksgegevens:</strong> Wij verzamelen informatie over hoe u onze dienst gebruikt, inclusief aangemaakte taken, beheerde projecten en gebruikspatronen van functies.
                </p>
                <p className="leading-relaxed">
                  <strong>Betalingsinformatie:</strong> Betalingsverwerking wordt afgehandeld door Polar. Wij slaan uw betaalkaartgegevens niet op onze servers op.
                </p>
                <p className="leading-relaxed">
                  <strong>Technische gegevens:</strong> Wij verzamelen automatisch bepaalde technische informatie, waaronder IP-adres, browsertype, besturingssysteem en apparaatinformatie.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Hoe wij uw informatie gebruiken</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Wij gebruiken de verzamelde informatie om:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Onze diensten te leveren, onderhouden en verbeteren</li>
                  <li>Transacties te verwerken en abonnementen te beheren</li>
                  <li>U technische meldingen en ondersteuningsberichten te sturen</li>
                  <li>Op uw opmerkingen en vragen te reageren</li>
                  <li>Gebruikspatronen te analyseren om de gebruikerservaring te verbeteren</li>
                  <li>Onze algemene voorwaarden te handhaven</li>
                  <li>Te voldoen aan wettelijke verplichtingen</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Informatie delen</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wij verkopen, verhandelen of dragen uw persoonlijke informatie niet over aan derden, behalve zoals beschreven in dit beleid:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Dienstverleners:</strong> Wij kunnen informatie delen met vertrouwde derden die ons helpen bij het exploiteren van onze dienst (bijv. Polar voor betalingsverwerking, Supabase voor databasediensten)</li>
                  <li><strong>Wettelijke vereisten:</strong> Wij kunnen informatie openbaar maken wanneer dit wettelijk vereist is of om onze rechten te beschermen</li>
                  <li><strong>Bedrijfsoverdrachten:</strong> In het geval van een fusie, overname of verkoop van activa kan gebruikersinformatie worden overgedragen</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Gegevensbeveiliging</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wij implementeren passende technische en organisatorische beveiligingsmaatregelen om uw persoonlijke informatie te beschermen tegen ongeautoriseerde toegang, wijziging, openbaarmaking of vernietiging. Geen enkele methode van verzending via internet is echter 100% veilig.
                </p>
                <p className="leading-relaxed">
                  <strong>Reactie op beveiligingsinbreuken:</strong> In het geval van een inbreuk op persoonsgegevens zullen wij voldoen aan de AVG:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Het incident binnen 72 uur na ontdekking melden aan de toezichthoudende autoriteit</li>
                  <li>Getroffen gebruikers op de hoogte stellen als de inbreuk een hoog risico vormt voor hun rechten en vrijheden</li>
                  <li>Maatregelen nemen om de impact te minimaliseren en toekomstige incidenten te voorkomen</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Gegevensbewaring</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wij bewaren uw persoonlijke informatie zo lang als nodig is om onze diensten te leveren. Specifieke bewaartermijnen zijn:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Accountgegevens:</strong> Duur van de dienst + 30 dagen na accountverwijdering</li>
                  <li><strong>Taakinhoud (sticky notes):</strong> Totdat u deze verwijdert of het account wordt beëindigd</li>
                  <li><strong>Betalingsgegevens:</strong> 7 jaar (vereiste Tsjechische boekhoudwetgeving)</li>
                  <li><strong>Analytische gegevens:</strong> Tot 26 maanden</li>
                  <li><strong>Back-upgegevens:</strong> Kunnen tot 90 dagen na primaire verwijdering bewaard blijven</li>
                  <li><strong>Geanonimiseerde gegevens:</strong> Onbeperkt bewaard voor statistische doeleinden</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Uw rechten onder de AVG</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">U heeft het recht om:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Toegang te krijgen tot de persoonlijke informatie die wij over u bewaren</li>
                  <li>Onjuiste persoonlijke informatie te corrigeren</li>
                  <li>Verwijdering van uw persoonlijke informatie te verzoeken</li>
                  <li>Bezwaar te maken tegen of de verwerking van uw informatie te beperken</li>
                  <li>Gegevensoverdraagbaarheid (een kopie van uw gegevens ontvangen in een gestructureerd formaat)</li>
                  <li>Toestemming op elk moment in te trekken</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Cookies en tracking</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wij gebruiken cookies en vergelijkbare trackingtechnologieën om uw ervaring te verbeteren. Soorten cookies die wij gebruiken:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Essentiële cookies:</strong> Noodzakelijk voor de functionaliteit van de dienst (authenticatie, inloggen)</li>
                  <li><strong>Analytische cookies:</strong> Helpen ons te begrijpen hoe u onze dienst gebruikt (u kunt deze weigeren)</li>
                  <li><strong>Cookies van derden:</strong> Google OAuth, Polar voor betalingen</li>
                </ul>
                <p className="leading-relaxed">
                  U kunt cookie-instellingen beheren via uw browservoorkeuren of onze cookiebanner bij uw eerste bezoek.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Diensten van derden</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">Onze dienst integreert met diensten van derden:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Google OAuth:</strong> Voor authenticatie (onderworpen aan het privacybeleid van Google)</li>
                  <li><strong>Polar:</strong> Voor betalingsverwerking (onderworpen aan het privacybeleid van Polar)</li>
                  <li><strong>Supabase:</strong> Voor database- en authenticatiediensten</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Privacy van kinderen</h2>
              <p className="leading-relaxed">
                Onze dienst is niet bedoeld voor kinderen jonger dan 16 jaar. Wij verzamelen niet bewust persoonlijke informatie van kinderen jonger dan 16 jaar. Als u een ouder of voogd bent en denkt dat uw kind ons persoonlijke informatie heeft verstrekt, neem dan contact met ons op via support@simplestickers.app.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Internationale gegevensoverdrachten</h2>
              <p className="leading-relaxed">
                Uw informatie kan worden overgedragen naar en verwerkt in landen anders dan uw land van verblijf. Wij zorgen ervoor dat passende waarborgen aanwezig zijn om uw persoonlijke informatie te beschermen in overeenstemming met de toepasselijke wetgeving inzake gegevensbescherming.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Wijzigingen in dit beleid</h2>
              <p className="leading-relaxed">
                Wij kunnen dit privacybeleid van tijd tot tijd bijwerken. Wij zullen u op de hoogte stellen van eventuele materiële wijzigingen door het nieuwe beleid op deze pagina te plaatsen en de datum "Laatst bijgewerkt" bij te werken.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Geautomatiseerde besluitvorming</h2>
              <p className="leading-relaxed">
                Onze dienst maakt gebruik van AI-algoritmen om taaksuggesties te genereren. Deze functie is puur ondersteunend en creëert geen beslissingen met juridische of significante gevolgen voor gebruikers. U kunt er op elk moment voor kiezen om geen suggesties te gebruiken.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Toezichthoudende autoriteit</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  U heeft het recht om een klacht in te dienen bij de toezichthoudende autoriteit voor gegevensbescherming:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p><strong>Tsjechisch Bureau voor Bescherming van Persoonsgegevens (ÚOOÚ)</strong></p>
                  <p className="text-sm mt-2">Pplk. Sochora 27, 170 00 Prague 7</p>
                  <p className="text-sm">Web: <a href="https://www.uoou.cz" className="text-indigo-600 hover:underline">www.uoou.cz</a></p>
                  <p className="text-sm">Email: posta@uoou.cz</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Hoe u uw rechten kunt uitoefenen</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Om uw rechten onder de AVG uit te oefenen (gegevenstoegang, rectificatie, verwijdering, overdraagbaarheid, bezwaar, enz.):
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Stuur ons een verzoek naar <strong>support@simplestickers.app</strong></li>
                  <li>Wij zullen binnen <strong>1 maand</strong> na ontvangst van uw verzoek reageren</li>
                  <li>Wij kunnen u vragen uw identiteit te verifiëren</li>
                  <li>De dienst is <strong>gratis</strong> (tenzij het verzoek kennelijk ongegrond of buitensporig is)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Contact opnemen</h2>
              <p className="leading-relaxed">
                Als u vragen heeft over dit privacybeleid of onze gegevenspraktijken, neem dan contact met ons op:
              </p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-700">
                  <strong>E-mail:</strong> support@simplestickers.app
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  Voor alle vragen over privacy, gegevensverzoeken, ondersteuning en andere vragen
                </p>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
